import {
	postPurchaseBat,
	postPurchaseCancel,
	postPurchaseRepeal,
	postPurchasePay,
	postPurchaseDelete,
	postPurchaseRestore,
} from "../../../api/wxshop/purchase.js";

function wrap(fn) {
	return (conText, payload) => {
		fn(payload.data || {}).then(res => {
			if (payload.success) payload.success(res)
		}).catch(err => {
			if (payload.error) payload.error(err)
		})
	}
}

let modules = {
	namespaced: true,
	state: {},
	mutations: {},
	actions: {
		postPurchaseBatAction: wrap(postPurchaseBat),
		postPurchaseCancelAction: wrap(postPurchaseCancel),
		postPurchaseRepealAction: wrap(postPurchaseRepeal),
		postPurchasePayAction: wrap(postPurchasePay),
		postPurchaseDeleteAction: wrap(postPurchaseDelete),
		postPurchaseRestoreAction: wrap(postPurchaseRestore),
	}
}
export default modules;
